
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class DataStreamEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.font = `${(10 + (config.parallaxLayers - layerIndex) * 5) * (config.parallaxScale || 1.0)}px monospace`;
        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            const speed = (1 + this.pseudoRandom(x) * 2) * config.parallaxSpeed;
            const offset = (time * 50 * speed) % spacing;
            
            for (let y = y1; y <= y2; y += spacing / 4) {
                const char = this.pseudoRandom(x + y + Math.floor(time * 10)) > 0.5 ? '1' : '0';
                
                const draw = () => {
                    ctx.fillText(char, x, y + offset);
                };

                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
